var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fill: "#4A4A4A",
    fontFamily: "Montserrat",
    fontSize: 38,
    fontWeight: 800,
    letterSpacing: 0,
    style: {
      whiteSpace: "pre"
    },
    transform: "rotate(-35.064 31.874 22.254)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 4,
    y: 27.04
  }, "\uD83C\uDF9F\uFE0F"))));
};
export default SvgTicket;